import React from 'react';
import { Check } from 'lucide-react';
import { useLanguage } from 'hooks/useLanguage';

const ProgressIndicator = ({ steps, currentStep }) => {
  const { t } = useLanguage();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.number}>
            <div className="flex flex-col items-center">
              {/* Step Circle */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
                  step?.number < currentStep
                    ? 'bg-green-500 text-white'
                    : step?.number === currentStep
                    ? 'bg-blue-500 text-white' :'bg-gray-200 text-gray-600'
                }`}
              >
                {step?.number < currentStep ? (
                  <Check className="w-5 h-5" />
                ) : (
                  step?.number
                )}
              </div>
              
              {/* Step Title */}
              <div className="mt-2 text-center">
                <p
                  className={`text-sm font-medium ${
                    step?.number <= currentStep
                      ? 'text-gray-900' :'text-gray-500'
                  }`}
                >
                  {step?.title}
                </p>
              </div>
            </div>
            
            {/* Connector Line */}
            {index < steps?.length - 1 && (
              <div className="flex-1 mx-4 h-px bg-gray-300 relative">
                <div
                  className={`h-full transition-colors ${
                    step?.number < currentStep
                      ? 'bg-green-500'
                      : step?.number === currentStep
                      ? 'bg-blue-500' :'bg-gray-300'
                  }`}
                  style={{
                    width: step?.number < currentStep ? '100%' : '0%',
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;